import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';

import { retryActionEnquiry } from './dao/EnquiryDao';
import { displayError } from '../component/Message/Message';

//
// Retry an enquiry action
//
export const retryEnquiry = (token: string, enquiryId: string, action: string, notification: string): Promise<AxiosResponse<void>> =>
    retryActionEnquiry(token, enquiryId, action, notification)
        .catch((error: any) => {
            const { t } = useTranslation();
            displayError(`${t('retry.service.action.error')} ${error}`);
            return Promise.reject(new Error(error));
          });
